(ns assemble.component.new-folder
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Dialog$default" :as Dialog]
            ["@mui/material/DialogActions$default" :as DialogActions]
            ["@mui/material/DialogContent$default" :as DialogContent]
            ["@mui/material/DialogTitle$default" :as DialogTitle]
            [assemble.assets-page.upload-modal.db]
            [clojure.string :as str]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [mate.re-frame :as mr]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn open-new-folder-modal [effects]
  (mr/update-db effects assoc ::new-folder {:modal-open true}))

(rf/reg-event-fx ::open-new-folder-modal
  (fn [{:keys [db]} _]
    (open-new-folder-modal {:db db})))

(defn close-new-folder-modal [effects]
  (mr/update-db effects dissoc ::new-folder))

(rf/reg-event-fx ::close-new-folder-modal
  (fn [{:keys [db]} _]
    (close-new-folder-modal {:db db})))

(rf/reg-sub ::new-folder-modal
  (fn [db]
    (::new-folder db)))

(defui new-folder-modal []
  (let [{:keys [modal-open command]} (use-subscribe [::new-folder-modal])
        children (set (use-subscribe [:assemble.page.assets.file-tree/child-names]))
        item-id (use-subscribe [:assemble.page.assets.file-tree/current-node-id])
        [name set-name] (uix/use-state "")

        {backend-error :error} command

        error (or (when (or (contains? children name)
                            ;; If someone else created the folder.
                            (and (:exists backend-error)
                                 (= name (:asset-tree/name (:exists backend-error)))))
                    "Folder already exist")
                  (when (and backend-error
                             (not (:exists backend-error)))
                    "Unknown error"))]
    ($ Dialog
       {:open (boolean modal-open)
        :onClose #(rf/dispatch [::close-new-folder-modal])
        :fullWidth true
        :maxWidth "xs"}
       ($ :form
          {:on-submit (fn [e]
                        (.preventDefault e)
                        (rf/dispatch [:assemble.resource.asset-tree/create-folder {:parent-id item-id
                                                                                   :folder-name name}]))}
          ($ DialogTitle {:variant "h2"}
             "New folder")
          ($ DialogContent
             ($ form-field
                {:label "Folder name"
                 :err-msg error}
                ($ input
                   {:autoFocus true
                    :error (boolean error)
                    :value name
                    :onChange (fn [e]
                                (let [new-value (-> e .-target .-value)]
                                  (set-name new-value)))})))
          ($ DialogActions
             ($ Button
                {:color "primary"
                 :onClick #(rf/dispatch [::close-new-folder-modal])}
                "Cancel")
             ($ Button
                {:variant "contained"
                 :color "primary"
                 :disabled (boolean (str/blank? name))
                 :type "submit"}
                "Create"))))))

(defui new-folder-button []
  ($ Button
     {:variant :contained
      :data-testid "newFolderButton"
      :onClick #(rf/dispatch [::open-new-folder-modal])}
     "New folder"))
